module.exports = __webpack_public_path__ + "static/media/04-gallery2.ec1dbd91.png";